import { BeforeYouStartTemplate, ContentBody } from '@templates';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@illegally-parked/routes/Routes';
import { CallToActionCardProps, InformationBox } from '@molecules/*';
import { v4 as uuidv4 } from 'uuid';
import { useParkingStore } from '@illegally-parked/store/store';

export const BeforeYouStart = () => {
  const navigate = useNavigate();
  const {
    updateSessionId,
    resetIssueDetails,
    resetYourDetails,
    updateCaseReferenceId,
    updateWantConfirmationEmail,
  } = useParkingStore();

  const contentTitle = 'Report an illegally parked vehicle';
  const sessionId = uuidv4();
  const initiateForm = () => {
    resetIssueDetails();
    resetYourDetails();
    updateCaseReferenceId('');
    updateWantConfirmationEmail(null);
    updateSessionId(sessionId);
    navigate(RoutesList.ISSUE_TYPE);
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: 'Start now',
    onClick: initiateForm,
  };
  const callToActionCards = [reportItCTA];

  const acceptReportContent = {
    sectionTitle: 'We accept reports about vehicles that:',
    itemList: [
      'have overstayed time limits',
      'are parked in a restricted zone without permission',
      'are parked in a way that might be blocking the road or pavement',
    ],
  };
  const detailsToProvideContent = {
    sectionTitle: 'To help resolve the issue quickly, we need to know:',
    itemList: ['the registration number', 'the location'],
  };
  const usefulToProvideContent = {
    sectionTitle: "It's useful to provide:",
    itemList: [
      'the make, model and colour of the vehicle',
      'photos of the issue',
    ],
  };
  const bodyContent = [
    acceptReportContent,
    detailsToProvideContent,
    usefulToProvideContent,
  ];

  const linkObjectArrays = [
    {
      level: 1,
      title: 'Home',
      href: 'https://www.westminster.gov.uk/',
    },
    {
      level: 2,
      title: 'Report it',
      href: 'https://www.westminster.gov.uk/report-it',
    },
    {
      level: 3,
      title: 'Illegally parked vehicle',
    },
  ];

  const informationBoxContent =
    '<p>We can only action on reports where we know the registration number of the vehicle. Please make sure you enter it correctly.</p>';

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={
        <>
          <ContentBody content={bodyContent} />
          <InformationBox
            infoText={informationBoxContent}
            variant="info"
            data-testid="information-box"
          />
        </>
      }
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
